import React from 'react';

function About() {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-blue-900">About Us</h2>
        <p className="text-lg text-gray-700 mb-6">
        At Eclipse Communications, LLC, we revolutionize contact centers with innovative, AI-driven solutions that redefine efficiency and customer connection. Built on the power of Amazon Connect and AWS cloud tech, we deliver systems that scale, workflows that work, and results that show—across any industry.
        </p>
        <p className="text-lg text-gray-700">
        Our AWS-experienced team has led global contact center migrations for tens of thousands of agents, hitting 99.95% uptime and driving cost savings. We serve developers, operators, and leaders:
        </p>
        <p>
          <br></br>
        <ul className="list-disc list-inside text-gray-700 text-center space-y-2">
            <li><b>Developers:</b> APIs and real-time data on AWS</li>
            <li><b>Operators:</b> Tools and AI for better interactions.</li>
            <li><b>Decision makers:</b> Lower costs and stronger outcomes.</li>
          </ul>
        </p>
        <br></br>
        <p className="text-lg text-gray-700">
        AI runs our core. Amazon Connect unifies data, powers self-service, and equips agents—handling over 10 million daily interactions for tens of thousands of customers, per AWS. Businesses worldwide cut costs (up to 70% in some cases) and lift service quality.
        </p>
      </div>
    </section>
  );
}

export default About;